import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const BoxFiltersDevices = (props) => {
    const { t: tC } = useTranslation("choices");
    const { t: _tT } = useTranslation("tables");
    function onChangeSelect(e) {
        const { name, value } = e.target;
        let named = name.replace("filter-", "");
        if (value) {
            props.filters.chosen[named] = value;
        } else {
            delete props.filters.chosen[named];
        }
        props.filters.filter();
    }

    function clearFilters() {
        props.filters.chosen = {};
        Object.keys(props.filters.list).forEach((key) => {
            const selectElement = document.getElementsByName("filter-" + key)[0];
            if (selectElement) {
                selectElement.value = "";
            }
        });
        props.filters.filter();
    }

    return (
        <Collapse in={props.show}>
            <div id="filter-collapse">
                <div className="row">
                    <Button
                        type="button"
                        variant="link"
                        onClick={clearFilters}
                        className="col-1"
                        title="Quitar filtros">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    {Object.keys(props.filters.list).map((key, idx) => (
                        <div className="col-2" key={idx}>
                            <label
                                style={{ width: "100%", fontWeight: "bold" }}>
                                {_tT(`devices.${key}`)}
                            </label>
                            <Form.Select
                                aria-label="Default select example"
                                name={"filter-" + key}
                                onChange={onChangeSelect}>
                                <option value="">{tC("devices.all")}</option>
                                {props.filters.list[key].map((item) => (
                                    <option key={key + "-" + item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    ))}
                </div>
            </div>
        </Collapse>
    );
};

export default BoxFiltersDevices;
